import axios from "axios";
import { apiPath } from "../../constants/config";

let token = localStorage.getItem("accessToken");
let config_headers = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadReservations: false,
  reservation_tables: [],
  tables_dispos: [],
  reservationss: [],
  reservations_table: [],
  reservationsPages: 0,
  reservationsExport: [],
  client_reservation:null,
};
const getters = {
  reservationss: state => state.reservationss,
  reservation_tables: state => state.reservation_tables,
  tables_dispos: state => state.tables_dispos,
  isLoadReservations: state => state.isLoadReservations,
  reservations_table: state => state.reservations_table,
  reservationsPages: state => state.reservationsPages,
  reservationsExport: state => state.reservationsExport,
  client_reservation: state => state.client_reservation,
};
const mutations = {
  setReservations(state, payload) {
    console.log(payload);
    console.log("%c HELLO ", "color:red;font-size:38px;");
    state.isLoadReservations = true;
    state.reservationss = payload.reservations;
    state.reservationsExport = payload.reservationsExport;
    state.reservationsPages = payload.total;
  },
  setReservationByTable(state, payload) {
    
    state.client_reservation = payload.data[0];
  },
  setReservationsTable(state, payload) {
    state.isLoadReservations = true;
    console.log(payload);
    state.reservations_table = payload.reservations;
  },
  updateReservation(state, payload) {
    let indexOf = state.reservationss.findIndex(
      item => item._id == payload.reservation._id
    );
    if (indexOf != -1) {
      state.reservationss.splice(indexOf, 1, payload.reservation);
    }
  },
  setReservation(state, payload) {
    console.log(payload);
    state.reservationss.unshift(payload.resrvation);
  },
  setReservation_tablesSuccess(state, payload) {
    state.reservation_tables = payload.reservation_tables;
  },
  setTables_disposSuccess(state, payload) {
    state.tables_dispos = payload.tables_dispos;
  }
};

const actions = {
  getTablesReservations({ commit }, payload) {
    return axios
      .get(`${apiPath}/getTables/${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setReservation_tablesSuccess", {
            reservation_tables: res.data
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  getReservations({ commit }, payload) {
    return axios
      .get(
        `${apiPath}/reservations/${payload.restaurant}?limit=${payload.limit}&page=${payload.page}&date=${payload.date}&dateTo=${payload.dateTo}`
      )
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setReservations", {
            reservations: res.data,
            total: res.total,
            reservationsExport: res.dataExport
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  getReservationsByTableDate({ commit }, payload) {
    return axios
      .post(`${apiPath}/reservations/table/date`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setReservationsTable", {
            reservations: res.data
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  updateStatusReservation({ commit }, payload) {
    return axios
      .post(`${apiPath}/status/reservations/${payload.restaurant}/${payload.reservation}`, payload.data)
      .then(res => res)
      .catch(error => error);
  },
  getTablesDispos({ commit }, payload) {
    return axios
      .get(`${apiPath}/tables_dispos/${payload.slug}`, {
        params: {
          date: payload.date,
          heure: payload.heure,
          rvc: payload.rvc
        }
      })
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setReservation_tablesSuccess", {
            reservation_tables: res.data
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  addReservation({ commit }, payload) {
    return axios
      .post(`${apiPath}/reservations/${payload.restaurant}`, payload.data)
      .then(res => res)
      .catch(error => error);

    // .then(res => {
    //   if (res.ok) {
    //     commit("setReservation", {
    //       resrvation: res.reservation
    //     });
    //     return res;
    //   } else {
    //     console.log(res);
    //     return res;
    //   }
    // });
  },
  updateReservationTable({ commit }, payload) {
    return axios
      .post(`${apiPath}/table/reservations/${payload.restaurant}`, payload.data)
      .then(res => res)
      .catch(error => error);

  },
  changeStatusReservation({ commit }, payload) {
    return axios
      .put(`${apiPath}/reservations/${payload._id}`, { status: payload.status })
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("updateReservation", {
            reservation: res.data
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  getReservationByTable({ commit }, payload) {
    return axios
      .post(`${apiPath}/get/reservation/by/table`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.data.length) {
          commit("setReservationByTable", {
            data: res.data
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
